import { useEffect } from 'react'
import {
  CollectingFormData,
  ReturningFormData,
  TransactionInputFormData,
} from 'src/components/forms/types'
import FormStepsStore from 'src/stores/forms/FormStepsStore'
import useTransactions from './api/useTransactions'
import { toJS } from 'mobx'
import { v4 } from 'uuid'
import { Transaction } from 'src/services/api/types'

export const useTransactionIdToSetFormData = (
  formStepsStore: FormStepsStore<
    CollectingFormData | ReturningFormData,
    TransactionInputFormData
  >,
  matchTransactionId: any
) => {
  const hook = useTransactions()
  const { data: transactionsPayload } = hook

  useEffect(() => {
    if (!matchTransactionId || formStepsStore.isEditMode) return

    const currentTransaction: Transaction | undefined = transactionsPayload?.data.find(
      item => item.id.toString() === matchTransactionId.toString()
    )

    if (!currentTransaction) return

    const mappedRows = currentTransaction.fustAantallen.map(item => ({
      id: v4(),
      col1: { value: item.fustCode },
      col2: { value: item.stapelwagens },
      col3: { value: item.stapels },
      col4: { value: item.stuks },
    }))

    formStepsStore.setFormData({
      information: {
        ...toJS(formStepsStore.formData.information),
        date: currentTransaction.datum as Date,
        createdOn: currentTransaction.createdOn,
        note: currentTransaction.externeNotitie,
        location: {
          id: currentTransaction.locatie,
          value: currentTransaction.locatie,
          label: currentTransaction.locatie,
        },
        packagingLocation: {
          id: currentTransaction.locatie,
          value: currentTransaction.locatie,
          label: currentTransaction.locatie,
        },
        transactieType:
          formStepsStore.formData.information.transactieType ||
          currentTransaction.transactieType,
      },
      transaction: {
        rows: mappedRows,
      },
    })

    formStepsStore.setEditTransactionId(matchTransactionId)
  }, [transactionsPayload])

  return hook
}
